"use client"

import { Button } from "@/components/ui/button"
import ContactModal from "@/components/ContactModal"
import { useState } from "react"

export function Contact() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <section className="flex items-center justify-center pb-16 md:pb-24" style={{ backgroundColor: 'rgb(245, 245, 247)' }}>
      <div className="mx-auto max-w-[110rem] px-4 sm:px-6 lg:px-10 w-full pt-16 md:pt-24">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-8 uppercase" style={{ color: 'rgb(29,29,31)', fontFamily: '"Universal Sans Display", -apple-system, Arial, sans-serif', letterSpacing: '0.025em' }}>
            Ready to bring your story to life?
          </h2>
          <p className="text-lg md:text-xl mb-8 leading-relaxed" style={{ color: 'rgba(0,0,0,0.88)' }}>
            We&apos;d love to hear about your project. Whether you have a clear vision or just an idea, let&apos;s work together to build something unforgettable.
          </p>
          
          <ContactModal
            open={isOpen}
            onClose={() => setIsOpen(false)}
          >
            <Button
              onClick={() => setIsOpen(true)}
              variant="default"
              className="px-8"
              style={{ backgroundColor: '#171A20', color: 'white' }}
            >
              Get in Touch
            </Button>
          </ContactModal>
        </div>
      </div>
    </section>
  )
}